import { render } from "./DSPReportingPage.vue?vue&type=template&id=59e135a6"
import script from "./DSPReportingPage.vue?vue&type=script&lang=js"
export * from "./DSPReportingPage.vue?vue&type=script&lang=js"

import "./DSPReportingPage.vue?vue&type=style&index=0&id=59e135a6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__